import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[adHost]'
})
export class ModalDirective {
	constructor(public viewContainerRef: ViewContainerRef) {}
}
